import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {Col, Divider, Row, Statistic} from 'antd'
import {Link} from 'react-router-dom'

import {Button, Card} from '@/components'
import {getAmountWithCurrency} from '@/utils'
import {AccountInfoHeaderCardProps} from './props'
import styles from './styles.scss'
import {CardTitle} from '@/components/composite/TransactionsCardWithBarChart/components'

export const AccountInfoHeaderCard: React.FC<AccountInfoHeaderCardProps> = observer(
    ({name, accountNumber, available, current, onClick}) => {
        const { t } = useTranslation()
        return (
            <Card
                title={
                    <CardTitle title={name}>
                        <Divider type={'vertical'} className={styles.divider} />
                        IBAN: {accountNumber}
                    </CardTitle>
                }
                extra={<Link to={'#'}>{t('AccountInfoHeaderCard.monthlyStatement')}</Link>}
                className={styles.card}
            >
                <Row justify={'space-between'} align={'middle'}>
                    <Col>
                        <Row align={'middle'}>
                            <Col>
                                <Statistic
                                    className={styles.statistic}
                                    title={t('AccountInfoHeaderCard.available')}
                                    value={getAmountWithCurrency(available)}
                                />
                            </Col>
                            <Divider className={styles.divider} type={'vertical'} />
                            <Col>
                                <Statistic
                                    className={styles.statistic}
                                    title={t('AccountInfoHeaderCard.current')}
                                    value={getAmountWithCurrency(current)}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <Button className={styles.button} ghost onClick={onClick}>
                            {t('AccountInfoHeaderCard.payAndTransfer')}
                        </Button>
                    </Col>
                </Row>
            </Card>
        )
    }
)
